import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightning02 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "lightning02",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.2495 2H8.494c-.1795 0-.2693 0-.3485.0273a.4999.4999 0 0 0-.1868.1155c-.0599.0586-.1.1389-.1803.2994l-4.2 8.4c-.1917.3834-.2875.5751-.2645.7309a.5.5 0 0 0 .208.3366C3.651 12 3.8654 12 4.294 12h6.2056l-3 10 12.193-12.6447c.4114-.4266.6171-.6399.6291-.8224a.5001.5001 0 0 0-.1763-.4149C20.0057 8 19.7094 8 19.1167 8h-7.1172l2.25-6Z"
    })
  }));
};
export default Lightning02;